export default {
  SCRIPT_REGEXP: /<script[^>]*>[^<]*<\/script>/,
  GLOBAL_HEADER_CODE: 'header-code',
  GLOBAL_FOOTER_CODE: 'footer-code',
  DEFAULT_OFFSET_X: 290,
  DEFAULT_OFFSET_Y: 50,
  DEFAULT_DIALOG_HEIGHT: 658,
  DEFAULT_DIALOG_WIDTH: 360,
  USER_FONTS_SCRIPT_TAG_ID: 'ws-user-font-pairs',
  MAX_OPACITY_VALUE: 1,
};
